// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"98df7958","488":"050b089d","681":"add59cb4","733":"0400823e","887":"050e50f7","918":"deaa8857"}[chunkId] + ".chunk.js";
};